module.exports = __webpack_public_path__ + "img/dingding.53c8839d.png";